<template>
  <div id="select-activa">
    <div class="d-flex flex-justify-center my-3" v-if="cargando">
      <div data-role="activity" data-type="ring" data-style="color"></div>
    </div>
    <template v-else-if="allVistas">
      <div class="p-1 text-small d-flex c-pointer" v-if="vistaActivaInicial" :key="`vista-activa-inicial`"
           @click="changeSelected(vistaActivaInicial)" style="gap: 8px;">
        <span class="badge inside bg-green fg-white border bd-black" style="left: 0; right: unset; font-size: 85%"
              v-if="vistaActivaInicial.id === idVistaActiva">
          Activo
        </span>
        <span class="badge inside bg-orange fg-white border bd-black" style="left: 0; right: unset; font-size: 85%"
              v-else-if="vistaActivaInicial.id === selectedVistaId">
          Seleccionada
        </span>
        <div class="k10-vista-pic-thumb">
          <img v-if="vistaActivaInicial.picture_url" :src="vistaActivaInicial.picture_url" alt=""
               class="k10-vista-pic-img">
          <div class="k10-vista-pic-siglas" :class="`k10-gradient-${vistaActivaInicial.default_gradient}`" v-else>
            <div>{{ nameSiglas(vistaActivaInicial.nombre) }}</div>
          </div>
        </div>
        <div class="text-left" style="overflow: hidden">
          <div class="text-medium elipsis-container">{{ vistaActivaInicial.nombre }}</div>
          <div class="fg-k10blue elipsis-container">@{{ vistaActivaInicial.username }}</div>
        </div>
      </div>

      <div class="p-1 text-small d-flex c-pointer" v-for="(vista,id) in allVistas"
           v-if="Number(id) !== idVistaActivaInicial" @click="changeSelected(vista)"
           :key="`otra-vista-${vista.id}`" style="gap: 8px;">
        <span class="badge inside bg-green fg-white border bd-black" style="left: 0; right: unset; font-size: 85%"
              v-if="Number(id) === idVistaActiva">
          Activo
        </span>
        <span class="badge inside bg-orange fg-white border bd-black" style="left: 0; right: unset; font-size: 85%"
              v-else-if="Number(id) === selectedVistaId">
          Seleccionada
        </span>
        <div class="k10-vista-pic-thumb">
          <img v-if="vista.picture_url" :src="vista.picture_url" alt="" class="k10-vista-pic-img">
          <div class="k10-vista-pic-siglas" :class="`k10-gradient-${vista.default_gradient}`" v-else>
            <div>{{ nameSiglas(vista.nombre) }}</div>
          </div>
        </div>
        <div class="text-left" style="overflow: hidden">
          <div class="text-medium elipsis-container">{{ vista.nombre }}</div>
          <div class="fg-k10blue elipsis-container">@{{ vista.username }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {siglas} from "@/mixins/koinonia10/siglas"

export default {
  name: "select-activa",
  data() {
    return {
      cargando: false,
      idVistaActivaInicial: null,
      selectedVistaId: null
    }
  },
  mixins: [siglas],
  computed: {
    allVistas() {
      return this.$store.getters.allVistas
    },
    vistaActivaInicial() {
      return this.allVistas[this.idVistaActivaInicial]
    },
    idVistaActiva() {
      return this.$store.getters.vistaActivaId
    }
  },
  async mounted() {
    await this.init()
  },
  async activated() {
    await this.init()
  },
  methods: {
    async init() {
      this.idVistaActivaInicial = this.idVistaActiva
      this.selectedVistaId = this.idVistaActiva
      if (!this.$store.getters.loadedAllVistas) {
        this.cargando = true
        await this.$store.dispatch('getAllVistas')
        this.cargando = false
      }
    },
    changeSelected(vista) {
      this.selectedVistaId = vista.id
      this.$emit('new-selected',vista.id)
    }
  }
}
</script>

<style scoped>

</style>